/*
 *   File : report.js
 *   Author : https://evoqins.com
 *   Description : Monthly reports page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import { format } from 'date-fns';

//Custom components
import { PrimaryButton, TextButton } from '../../Components/Buttons';
import { CustomSearchInput } from '../../Components/FormElements';
import { ConfirmModal, PreviewModal, SendReportModal } from '../../Components/Modal';
import { CustomRadio, EmptyScreen, Loader } from '../../Components/Others';
import { APIService } from '../../Service';

//Colors
import Color from "../../Style/color.scss";
import style from "../../Style/Component/report.module.scss"
import { Icon } from '../../Components/Icon';

const USER_SELECT_DATA = [
    {
        id: 1,
        label: "All users",
    },
    {
        id: 2,
        label: "Specific users"
    }
];

const USER_DATA = [
    {
        id: 1,
        label: 'Sample 1',
        value: 'Sample 1',
    },
    {
        id: 2,
        label: 'Sample 2',
        value: 'Sample 2',
    },
    {
        id: 3,
        label: 'Sample',
        value: 'Sample 3'
    },
    {
        id: 4,
        label: 'Sample',
        value: 'Sample'
    }
];

const Reports = () => {

    const hasFetchedRef = useRef(false);

    const [selected, setSelected] = useState(1);

    const [selectedUsersError, setSelectedUsersError] = useState("");
    const [reportModal, setReportModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);

    const [searchValue, setSearchValue] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [userList, setUserList] = useState([]);
    const [sampleReport, setSampleReport] = useState(false);

    const [loader, setLoader] = useState(true);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [showSelected, setShowSelected] = useState(false);

    const [userCount, setUserCount] = useState({ invested: 0, non_invested: 0 });

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (selected === 2) {
            _userList();
        }
    }, [searchValue, selected]);

    useEffect(() => {
        if (selected === 1) {
            if (hasFetchedRef.current) return;
            hasFetchedRef.current = true;
            _userList();
        }
    }, [selected]);

    useEffect(() => {
        setSelectedUsersError("");
    }, [selectedUsers]);

    useEffect(() => {
        if (reportModal === true) {
            const report_modal = new Modal(document.getElementById('send-report-modal'));
            report_modal.show();
        }
    }, [reportModal]);

    useEffect(() => {
        if (sampleReport === true) {
            const sample_report = new Modal(document.getElementById("preview-modal"));
            sample_report.show();
        }
    }, [sampleReport]);


    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    useEffect(() => {
        if (selectedDate !== null) {
            setConfirm(true);
        }
        console.log("selectedDate", selectedDate);

    }, [selectedDate])

    // handle select user 
    const _handleSelect = (id) => {
        setSelected(id);
        setSelectedUsers([]);
    };

    // handle send report 
    const _handleSendReport = (type) => {
        if (type === 1) {
            setReportModal(true);
        } else {
            if (selectedUsers.length === 0) {
                // setSelectedUsersError("Please select atleast one user");
                toast.dismiss();
                toast.error("Please select atleast one user", {
                    type: "error",
                    className: "e-toast",
                });
                return;
            }
            setReportModal(true);
        }
    };

    // handle send month 
    const _handleSend = (date) => {
        setSelectedDate(date);
    };

    // handle confirm 
    const _handleConfirm = () => {
        _sendReport();
    };

    // handle select users 
    const _handleSelectUser = (users) => {
        setSelectedUsers(prevUsers =>
            prevUsers.find(item => item === users)
                ? prevUsers.filter(item => item !== users)
                : [...prevUsers, users]
        );
    };

    // handle submit selected 
    const _handleSubmit = () => {
        setSearchValue("");
        setShowSelected(true);
    };

    // handle view
    const _handleView = () => {
        setSampleReport(true)
    };

    // API - Send monthly report
    const _sendReport = () => {

        let updated_customers = [];

        updated_customers = selectedUsers.map(data => (
            data.customer_id
        ));

        const input_date = format(selectedDate, "yyyy-MM");

        let is_post = true;
        let url = 'reports/monthly';
        let data = {
            "customer_id": updated_customers,
            "selected_month": input_date
        };

        setButtonLoader(true);
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setStatus(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setButtonLoader(false);
        });
    };

    // API -  user listing
    const _userList = () => {

        let is_post = true;
        let url = 'user/list';
        let request = {
            "query": searchValue,
            "page_num": 1,
            "page_size": selected === 1 ? 1 : 20,
            "investment_status": 1,
        }
        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setUserList(response.data.data);
                setUserCount({
                    invested: response.data.total_invested_users_count,
                    non_invested: response.data.total_non_invested_users_count,
                });
            } else {
                setUserList([]);
            }
            setLoader(false);
        });
    };

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <h3 className='mb-0 e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                        Monthly Reports
                    </h3>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div className='e-bg-white border-radius-16 padding-32px-all min-vh-50'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                Users selection
                            </h4>
                            <div className='d-flex align-items-center gap-36px'>
                                <TextButton name="View Sample report"
                                    className="padding-12px-tb e-hover"
                                    onClick={_handleView} />
                                {selected === 1 &&
                                    <PrimaryButton name="Send Report"
                                        paddingBlock="padding-12px-tb padding-44px-lr"
                                        onClick={() => _handleSendReport(1)} />
                                }
                            </div>
                        </div>

                        {/* user selection */}
                        <div className='padding-14px-top '>

                            {/* Custom radio button */}
                            <CustomRadio data={USER_SELECT_DATA}
                                selected={selected}
                                className="d-flex flex-column gap-3"
                                handleSelect={_handleSelect} />

                            {/* Add users */}
                            {selected === 2 ?
                                <div className='row pt-3'>
                                    <div className='col-5'>
                                        <div className='position-relative'>
                                            <CustomSearchInput placeholder="Search with customer ID or name"
                                                type="text"
                                                value={searchValue}
                                                className="w-100"
                                                clearIcon='top-14px right-38px'
                                                onClear={() => setSearchValue("")}
                                                handleChange={(e) => setSearchValue(e)} />

                                            {selectedUsersError &&
                                                <p className={`position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                                                    {selectedUsersError}
                                                </p>
                                            }

                                            <div className='pt-2'>
                                                {showSelected === true &&
                                                    <div className='d-flex align-items-center gap-2 flex-wrap'>
                                                        {selectedUsers.map((users, key) => (
                                                            <div key={key} className='e-bg-lavender-blue d-flex align-items-center gap-1 px-2 py-1 border-radius-8'>
                                                                <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                    {users.name}
                                                                </p>
                                                                <Icon icon="close"
                                                                    size={12}
                                                                    className="d-flex cursor-pointer"
                                                                    onClick={() => _handleSelectUser(users)} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                            </div>

                                            {searchValue.length > 0 &&
                                                <div className={`${style.e_user_wrapper} e-bg-white border-radius-8 p-3 d-flex flex-column gap-2 position-absolute w-100 top-48px z-1`}>
                                                    <div className='d-flex justify-content-end'>
                                                        <TextButton name="Clear all"
                                                            onClick={() => setSelectedUsers([])} />
                                                    </div>
                                                    {loader ?
                                                        <Loader className="py-5"
                                                            width={60}
                                                            height={60} />
                                                        :
                                                        <>
                                                            {userList.length !== 0 ?
                                                                <>
                                                                    <div className={`${style.e_lists} d-flex flex-column gap-2 overscroll-behavior-none `}>
                                                                        {userList.map((user, key) => (
                                                                            <div key={key} className='d-flex gap-2  align-items-start cursor-pointer'
                                                                                onClick={() => _handleSelectUser(user)}>
                                                                                <Icon icon={selectedUsers.includes(user) ? "checkbox-active" : "checkbox-inactive"}
                                                                                    size={16}
                                                                                    className='cursor-pointer d-flex margin-2px-top' />
                                                                                <div>
                                                                                    <p className='mb-1 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-16px'>
                                                                                        {user.name}
                                                                                    </p>
                                                                                    <p className='mb-0 e-text-davys-grey e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                                        {user.rayi_customer_id}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        ))}

                                                                    </div>
                                                                    <PrimaryButton name="Confirm"
                                                                        paddingBlock="padding-10px-all"
                                                                        onClick={_handleSubmit} />
                                                                </>
                                                                :
                                                                <EmptyScreen width={48}
                                                                    height={48}
                                                                    padding="py-5 my-0"
                                                                    fontSize="e-font-14 line-height-20px"
                                                                    image={require('../../Assets/Image/NotFound/no-data.png')}
                                                                    description='No data found'
                                                                />
                                                            }
                                                        </>}
                                                </div>
                                            }
                                        </div>
                                        <div className='pt-4 mt-3 text-end'>
                                            <PrimaryButton name="Send Report"
                                                paddingBlock="padding-12px-tb padding-34px-lr"
                                                disabled={selectedUsers.length === 0}
                                                className='position-relative z-0'
                                                onClick={() => {
                                                    if (selectedUsers.length !== 0) {
                                                        _handleSendReport(2);
                                                    }
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='pt-4 mt-2'>
                                    <ul className='ps-3'>
                                        <li className='mb-1 e-text-smoky-black e-primary-font e-font-14 e-font-weight-400 line-height-20px'>
                                            Invested user count: <span className='e-font-weight-600'>{userCount.invested || "-"}</span>
                                        </li>
                                        <li className='mb-0 e-text-smoky-black e-primary-font e-font-14 e-font-weight-400 line-height-20px'>
                                            Non-invested user count: <span className='e-font-weight-600'>{userCount.non_invested || "-"}</span>
                                        </li>
                                    </ul>
                                </div>
                            }


                        </div>
                    </div>
                </div>
            </section>

            {/* Send report modal */}
            {reportModal === true &&
                <SendReportModal
                    handleClose={() => {
                        setTimeout(() => {
                            setReportModal(false);
                        }, 200);
                    }}
                    handleSuccess={_handleSend} />
            }

            {/* confirm modal */}
            {confirm === true &&
                <ConfirmModal title={status ? "Sent successfully" : "Send monthly reports"}
                    description={status ? "The report has  been sent successfully." :
                        <div>
                            {/* Are you sure you want to send the report to selected users? */}

                            <p className='mb-2'>
                                Are you sure you want to send the report for <strong>{selectedDate}</strong> to the following users?
                            </p>

                            {selectedUsers.length !== 0 &&
                                <div className='d-flex align-items-center gap-2 flex-wrap'>
                                    {selectedUsers.map((users, key) => (
                                        <div key={key} className='e-bg-lavender-blue px-2 py-1 border-radius-4'>
                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                {users.name}
                                            </p>
                                        </div>

                                    ))}
                                </div>
                            }
                        </div>
                    }
                    status={status}
                    loader={buttonLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            setSelectedUsers([]);
                            setSelectedDate(null);
                            setButtonLoader(false);
                        }, 200);
                    }}
                    handleConfirm={_handleConfirm}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            setSelectedUsers([]);
                            setSelectedDate(null);
                            setButtonLoader(false);
                        }, 200);
                    }} />

            }

            {sampleReport === true &&
                <PreviewModal type={2}
                    title="View Sample report"
                    button={false}
                    handleClose={() => {
                        setTimeout(() => {
                            setSampleReport(false);
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default Reports;
